export const TOGGLE_POINTS_VISIBLE = 'toggle-points-visible';
export const TOGGLE_HANDS_VISIBLE = 'toggle-hands-visible';
export const TOGGLE_BID_HINTS_VISIBLE = 'toggle-bid-hints-visible';
export const TOGGLE_AUCTION_VISIBLE = 'toggle-auction-visible';
export const APP_SETTINGS_UPDATE = 'app-settings-update';
